import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function LangToggle({ compact = false }) {
  const { toggleLang, t, lang } = useLanguage();
  const label = compact ? (lang === 'te' ? 'En' : 'తె') : t('langToggle');
  return (
    <button
      type="button"
      className={`lang-toggle${compact ? ' lang-toggle-compact' : ''}`}
      onClick={toggleLang}
      aria-label={t('profile.language') || 'Switch language'}
    >
      {label}
    </button>
  );
}
